import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import Container from '../container/Container';
import searchBarStyles from '@/components/search-bar/search-bar.module.css';
import './form-input.styles.css';
import clsx from 'clsx';
import { MdSearch } from 'react-icons/md';
import { cn } from '../ui/cn';

type Props = {
	id?: string;
	variant?: 'outlined' | 'filled';
	value?: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	placeholder?: string;
	testId?: string;
};

const SearchBar = (props: Props) => {
	const { className, id, onChange, variant, value, placeholder } = props;
	return (
		<div
			className={cn(
				searchBarStyles.searchbarContainer,
				"bg-surfaceContainerHigh",
				'rounded-full',
				className
			)}
			style={{ height: '56px' }}
		>
			<MdSearch className={searchBarStyles.searchbarIcon} />
			<InputText
				unstyled
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				className={cn(searchBarStyles.searchbarInput)}
				style={{ backgroundImage: 'none' }}
			/></div>
	)
};

export default SearchBar;
